import React, { CSSProperties } from "react";

import styled from "styled-components";

import {
    BIG_NAV_PX_HEIGHT,
    colorCSS,
    containerWidths,
    minWidth,
    shadow,
    zIndex
} from "../../../styles";

export const DetailWrapper: React.FC<{
    children: React.ReactNode;
    style?: CSSProperties;
}> = ({ children, style }) => (
    <div
        style={{
            overflow: "hidden",
            transition: "height 0.3s ease",
            ...style
        }}
    >
        {children}
    </div>
);

const StyledHeader = styled.header<{ "$isOpen": boolean; "$is-open": boolean }>`
    background-color: ${(props) =>
        props.$isOpen ? colorCSS("N900", 0.5) : colorCSS("N900", 0)};
    display: none;
    height: ${(props) => (props.$isOpen ? "100vh" : 0)};
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    cursor: ${(props) => (props.$isOpen ? "pointer" : "default")};
    transition: ${(props) =>
        props.$isOpen
            ? "background-color 0.6s ease, height 0s linear"
            : "background-color 0.6s ease, height 0s linear 0.6s"};
    z-index: ${zIndex.headerShroud};

    @media ${minWidth.lg} {
        display: block;
    }
`;

export const Header: React.FC<{
    "children": React.ReactNode;
    "data-open"?: string;
}> = ({ children, "data-open": dataOpen }) => {
    const isOpen = dataOpen === "true";

    return (
        <StyledHeader $isOpen={isOpen} $is-open={isOpen}>
            {children}
        </StyledHeader>
    );
};

export const InnerHeader: React.FC<{
    "children": React.ReactNode;
    "data-start-transparent"?: string;
    "data-active"?: string;
}> = ({
    children,
    "data-start-transparent": startTransparent,
    "data-active": dataActive
}) => {
    const [isHovered, setIsHovered] = React.useState(false);
    const isStartTransparent = startTransparent === "true";
    const isActive = dataActive === "true";

    return (
        <div
            data-start-transparent={startTransparent}
            data-active={String(isActive || isHovered)}
            style={{
                backgroundColor:
                    isStartTransparent && !isActive && !isHovered
                        ? colorCSS("N0", 0.85)
                        : colorCSS("N0", 1),
                boxShadow: isActive || isHovered ? shadow.normal : "none",
                cursor: "default",
                position: "fixed",
                top: 0,
                transition: "0.5s background-color ease, 0.5s box-shadow ease",
                width: "100vw",
                zIndex: zIndex.header
            }}
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseEnter={() => setIsHovered(true)}
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
        </div>
    );
};

export const NavBar: React.FC<{ children: React.ReactNode }> = ({
    children
}) => (
    <div
        style={{
            alignItems: "stretch",
            display: "flex",
            height: `${BIG_NAV_PX_HEIGHT}px`,
            margin: "0 auto",
            maxWidth: `${containerWidths.xxl}px`,
            padding: "0 1rem",
            width: "100%"
        }}
    >
        {children}
    </div>
);
